<script lang="ts">
	import type { Device } from 'src/types/Device';
	import type { ViewCategory } from 'src/types/DeviceUI';
	import {
		sidepanelViewSelection,
		sidepanelViewSwitcherAvailable,
	} from 'src/stores/features/dev/sidepanel-view-switcher';
	import { viewComponentRegistry } from 'src/components/Sidepanel/view-registry';
	import { getCurrentView } from 'src/components/Sidepanel/view-helpers';

	export let device: Device;
	export let categoryOverride: ViewCategory | undefined;
	export let viewProps: Record<string, unknown> = {};

	$: viewDevice = categoryOverride ? { ...device, category: categoryOverride } : device;
	$: current = getCurrentView(viewDevice, {
		switcherEnabled: $sidepanelViewSwitcherAvailable,
		selected: $sidepanelViewSelection[device?.id],
	});
	$: registryKey =
		device?.type === 'peripheral-device' ? 'peripheral_device' : (current?.category ?? 'relay');
	$: component =
		viewComponentRegistry?.[registryKey]?.[current?.variant] ??
		viewComponentRegistry?.[registryKey]?.['basic'] ??
		viewComponentRegistry?.['relay']?.['basic'];
</script>

{#if component}
	<svelte:component this={component} {device} {...viewProps} />
{/if}
